import { render } from "./Informations.vue?vue&type=template&id=d6737834&scoped=true"
import script from "./Informations.vue?vue&type=script&lang=js"
export * from "./Informations.vue?vue&type=script&lang=js"

import "./Informations.vue?vue&type=style&index=0&id=d6737834&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d6737834"

export default script